export const DEFAULT_MAKE_BANNER = "https://partsavatar.ca/images/banners/fallback-make.webp";
export const DEFAULT_MAKE_MODEL_BANNER = "https://partsavatar.ca/images/banners/fallback-make-model.webp";
export const DEFAULT_CATEGORY_BANNER = "https://partsavatar.ca/images/banners/fallback-fallback.webp";
